// extracted by mini-css-extract-plugin
export default {"flex_container":"SoundramaPageSite_flex_container__RZvZB","text":"SoundramaPageSite_text__CKazq","img":"SoundramaPageSite_img__rZi9e"};